import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { getChargebackScoreboard } from "../../api";

const initialState = {
  merchantList: [],
  merchantListLoading: false,
  merchantFilterSearchQuery: {
    left_progression_filter: "active",
    search: "",
    sortBy: "volume_mtd",
    sortValue: "DESC",
    manager_id: [],
    progression_id: [],
    page: 1,
    merchants: true,
    merchant_filter: null,
  },
  filterBoundsLoading: true,
  filterBounds: {
    volume_cap: { min: 0, max: 0 },
    volume_used: { min: 0, max: 0 },
    volume_mtd: { min: 0, max: 0 },
    mom_change: { min: 0, max: 0 },
  },
  pageCount: 0,
  currentPage: 1,
  totalItems: 0,
  itemsPerPage: 50,
  activeAppId: null,
  activeApp: null,
  chargebacksData: null,
  chargebacksVolumeFilter: {
    type: "volume",
    year: 2024,
  },
  chargebacksDataLoading: true,
  chargebackScoreboard: null,
  chargebackScoreboardLoading: true,
  chargebackScoreboardError: null,
};

const useMerchantStore = create(
  devtools((set) => ({
    ...initialState,
    setActiveAppId: (id) => set({ activeAppId: id }),
    setActiveApp: (app) => set({ activeApp: app }),
    setMerchantList: (list) => set({ merchantList: list }),
    setMerchantListLoading: (loading) => set({ merchantListLoading: loading }),
    setMerchantFilterSearchQuery: (query) =>
      set((state) => ({
        merchantFilterSearchQuery: {
          ...state.merchantFilterSearchQuery,
          ...query,
        },
      })),
    setFilterBounds: (bounds) => set({ filterBounds: bounds }),
    setFilterBoundsLoading: (l) => set({ filterBoundsLoading: l }),
    setChargebacksVolumeFilter: (data) =>
      set((state) => ({
        chargebacksVolumeFilter: {
          ...state.chargebacksVolumeFilter,
          ...data,
        },
      })),
    setChargebacksData: (data) => set({ chargebacksData: data }),
    setChargebacksDataLoading: (data) => set({ chargebacksDataLoading: data }),
    setPageCount: (count) => set({ pageCount: count }),
    setCurrentPage: (page) => set({ currentPage: page }),
    setTotalItems: (total) => set({ totalItems: total }),
    setItemsPerPage: (items) => set({ itemsPerPage: items }),
    reset: () => set(initialState),
  })),
);

export const fetchChargebackScoreboard = async (
  mid,
  startDate,
  endDate,
  abortController,
) => {
  try {
    useMerchantStore.setState({
      chargebackScoreboardLoading: true,
    });

    const res = await getChargebackScoreboard(
      { mid, startDate, endDate },
      abortController,
    );

    if (!res?.status) {
      useMerchantStore.setState({
        chargebackScoreboardError:
          res?.message || "Error fetching chargeback scoreboard",
        chargebackScoreboardLoading: false,
      });
      return;
    }

    useMerchantStore.setState({
      chargebackScoreboard: res?.data,
      chargebackScoreboardLoading: false,
      chargebackScoreboardError: null,
    });
  } catch (err) {
    if (err.name === "AbortError") {
      return;
    }
    console.error("Chargeback scoreboard fetch error:", err);
    useMerchantStore.setState({
      chargebackScoreboardError:
        err.message || "Error fetching chargeback scoreboard",
      chargebackScoreboardLoading: false,
    });
  }
};

export default useMerchantStore;
